export const ItemTypes = {
  FUND: 'FUND',
};
